import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, ListChecks, LogOut, Settings, KeyRound } from "lucide-react";
import BrandMark from "@/components/BrandMark";

export default function AdminLayout({ children }) {
  const nav = useNavigate();
  const logout = () => {
    localStorage.removeItem("sms_admin_token");
    nav("/admin/login");
  };

  const linkBase =
    "flex items-center gap-3 px-4 py-2.5 mx-3 my-1 text-sm font-medium rounded-lg transition-all";
  const linkActive = "bg-gradient-to-r from-turq-600 to-cyan-500 text-white shadow-md shadow-turq-500/30";
  const linkIdle = "text-slate-600 hover:bg-turq-50 hover:text-turq-700";

  return (
    <div className="min-h-screen bg-background flex">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-turq-100/80 flex flex-col" data-testid="admin-sidebar">
        <div className="px-6 py-6">
          <div className="flex items-center gap-3">
            <BrandMark variant="icon" className="w-9 h-9" />
            <div>
              <div className="font-display font-black text-base text-slate-900 leading-none">SMS PANEL</div>
              <div className="tiny-label mt-1">E-Telekom Admin</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 py-2">
          <NavLink to="/admin" end className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-dashboard">
            <LayoutDashboard className="w-4 h-4" /> Panel
          </NavLink>
          <NavLink to="/admin/customers" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-customers">
            <Users className="w-4 h-4" /> Müşteriler
          </NavLink>
          <NavLink to="/admin/jobs" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-jobs">
            <ListChecks className="w-4 h-4" /> SMS Logları
          </NavLink>
          <NavLink to="/admin/settings" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-settings">
            <Settings className="w-4 h-4" /> Gateway Ayarları
          </NavLink>
          <NavLink to="/admin/password" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-password">
            <KeyRound className="w-4 h-4" /> Şifre Değiştir
          </NavLink>
        </nav>
        <div className="p-4 border-t border-turq-100/80">
          <button
            onClick={logout}
            data-testid="logout-btn"
            className="w-full flex items-center justify-center gap-2 text-sm font-semibold py-2.5 border border-turq-100 text-slate-600 rounded-lg hover:bg-turq-50 hover:text-turq-700 transition-colors"
          >
            <LogOut className="w-4 h-4" /> Çıkış
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0">
        <div className="p-8 max-w-[1400px]">{children}</div>
      </main>
    </div>
  );
}
